import { createContext } from 'react';

export const FigureChannelAdjustmentContext = createContext({})

export const CropAdjustmentDispatch = createContext({});
export const VerticalTranslationContext = createContext({y:0});

export const FilesysteItemContext = createContext({});

export const TemplateNodeStyleContext = createContext();
export const ExpansionTemplateInfo = createContext();
export const ExpansionWindowFocusContext = createContext({});

export const GridBoundaryAdjustmentContext = createContext();
export const ColumnResizeContext = createContext({});
export const CropAdjustmentContext = createContext({});
export const FilesystemDragContext = createContext({});
export const FilesystemColumnWidthContext = createContext({});
export const FilesystemItemHoverContext = createContext({});


export const FilesystemItemContext = createContext({});
export const FilesystemHierarchyContext = createContext();

export const QuantificationListContext = createContext();

export const QuantificationUpdateMenuContext = createContext();

export const RowDragContext = createContext({});

export const FilesystemStore = createContext();

export const AnnotationStyleContext = createContext({});

export const DiscountContext = createContext({});

export const PricingConfigContext = createContext({});

export const DrawingContext = createContext({});

export const FigureInteractionContext = createContext({});

export const GridCellContext = createContext();

export const ContextMenuContext = createContext({});

export const CellResizeContext = createContext({});

export const TemplateEditingContext = createContext();

export const ModalDispatch = createContext();

export const NodeDisplayContext = createContext();

export const SelectedCoverContext = createContext();

export const FigureInteractionEventDispatch = createContext();

export const SelectedItemsContext = createContext();

export const TemporaryAdjustmentsContext = createContext();

export const WidthResizeContext = createContext({dw:0,dh:0});

export const NodeBoundsContext = createContext({});

export const TemplateChannelPickerContext = createContext({});

export const FocusedAnnotationContext = createContext({});

export const ThemeContext = createContext();
